import React, { useRef, useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import Footer from "./footer";
import ReactTyped from "react-typed";
import Header from "./header";
import { Box, Typography, Container, Grid, Button, Card } from "@mui/material";

/** Smooth-scroll to hash target on route change */
function useScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        // Give the browser a tick in case content/layout just mounted
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
      }
    } else {
      // Optional: scroll to top when coming to /about without hash
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location]);
}

function About() {
  useScrollToHash();

  const textList = ["Mission.", "Vision.", "Planning.", "AISECT"];
  const [nameIndex, setNameIndex] = useState(0);
  const intervalId = useRef();

  return (
    <>
      <Header />

      {/* ======= Hero / Banner ======= */}
      <div id="about-top" className="rbt-banner-area rbt-banner-8 variation-02">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-10 offset-lg-1">
              <div className="content text-center">
                <div className="rbt-new-badge rbt-new-badge-one">
                  <span className="rbt-new-badge-icon">🏆</span> The Leader in Campus Learning
                </div>
                <h1 className="title">
                  Read About Our{" "}
                  <Box component="span">
                    <ReactTyped
                      className="theme-gradient is-visible"
                      strings={textList}
                      typeSpeed={100}
                      loop
                      backSpeed={20}
                      cursorChar=">"
                      showCursor={true}
                    />
                  </Box>
                </h1>
                <p className="description has-medium-font-size mt--20">
                  AISECT Inter College, We provide the best possible learning environment through our best
                  teaching and learning experiences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ======= About Section ======= */}
      {/* ======= About Section (polished) ======= */}
<div className="rbt-about-area about-style-1 bg-color-white rbt-section-gap">
  <Container maxWidth="lg">
    <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
      {/* Image */}
      <Grid item xs={12} md={5} sx={{ textAlign: { xs: "center", md: "left" } }}>
        <Box
          component="img"
          src="/assets/images/logo/aisect_inter_college_logo.png"
          alt="About AISECT"
          sx={{
            width: { xs: 220, sm: 260, md: 320 },
            height: "auto",
            display: "inline-block",
            borderRadius: 3,
            boxShadow: "0 12px 32px rgba(0,0,0,.08)",
          }}
        />
      </Grid>

      {/* Text */}
      <Grid item xs={12} md={7}>
        <Box sx={{ maxWidth: "65ch", ml: "auto" }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 1.25,
              py: 0.5,
              borderRadius: 9999,
              bgcolor: "primary.main",
              color: "primary.contrastText",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 0.4,
              mb: 1.5,
            }}
          >
            ABOUT AISECT
          </Box>

          <Typography
            component="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: 22, sm: 26, md: 30 },
              lineHeight: 1.25,
              mb: 1.25,
            }}
          >
            Welcome to AISECT Inter College for your learning & skills upgradation.
          </Typography>

          <Typography
            sx={{
              fontWeight: 800,
              fontSize: { xs: 15.5, md: 16.5 },
              lineHeight: 1.6,
              mb: 1,
            }}
          >
            AISECT Inter College is an educational institute
          </Typography>

          <Typography sx={{ color: "text.secondary", fontSize: { xs: 15, md: 16 }, lineHeight: 1.9, mb: 1 }}>
            The AISECT Inter College (Letter No./JAC/Co Est./485/17 – 4693/22) dated 29.12.2022 was
            established in June 2023. It aims to build future citizenship inspired by the vision, mission,
            and ultimate goal of our institution. We wish for the overall development of our students—
            academic, physical, creative, social, and global understanding—along with skill development.
          </Typography>

          <Typography sx={{ color: "text.secondary", fontSize: { xs: 15, md: 16 }, lineHeight: 1.9, mb: 1 }}>
            Our courses prepare students to meet challenges in Arts, Science, and Commerce. The college is
            affiliated to Jharkhand Academic Council (JAC), Ranchi. We are in process for permanent
            affiliation to increase student intake; this will also enable scholarship support.
          </Typography>

          <Typography sx={{ color: "text.secondary", fontSize: { xs: 15, md: 16 }, lineHeight: 1.9 }}>
            With dedicated teachers and committed staff, we provide personal care and values-based education.
            We believe long-term success grows in a supportive, transparent environment—helping students
            become responsible citizens and future leaders.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Container>
</div>


      {/* ======= Two-Column Row: Principal + About (Cards) ======= */}
      <Container
        maxWidth="lg"
        sx={{
          mt: { xs: 2, md: -6 },
          mb: { xs: 4, md: 6 },
          position: "relative",
          zIndex: 2,
        }}
      >
        <Grid container spacing={{ xs: 2, sm: 2.5 }} alignItems="stretch">
          {/* Principal’s Message */}
          <Grid item xs={12} md={7} id="principalmessage">
  <Card
    elevation={0}
    sx={{
      p: { xs: 2, sm: 2.5 },
      borderRadius: 3,
      height: "100%",
      display: "flex",
      gap: { xs: 2, sm: 2.5 },
      alignItems: "stretch", // makes image stretch to full height
      boxShadow: "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
      border: (t) => `1px solid ${t.palette.divider}`,
      bgcolor: "background.paper",
    }}
  >
    <Box
      component="img"
      src="/assets/images/team/principal.jpeg"
      alt="Smt. Mamta Sharma"
      loading="lazy"
      sx={{
        width: { xs: 110, sm: 140 }, // controls image width only
        height: "100%", // fills entire card height
        borderRadius: 2.5,
        objectFit: "cover",
        objectPosition: "center",
        flexShrink: 0,
        boxShadow: "0 6px 18px rgba(0,0,0,.12)",
      }}
    />
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography sx={{ fontWeight: 800, fontSize: { xs: 17, sm: 18.5 }, mb: 0.5 }}>
        From Principal's Desk
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: { xs: 15, sm: 16 }, mb: 1 }}>
        Smt. Mamta Sharma
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          fontSize: { xs: 15, sm: 16 },
          lineHeight: 1.6,
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        It is with great pride and enthusiasm that I welcome you to our college in its 3rd year of
        establishment. Though still young, the institution has already begun to make a mark through a
        commitment to academic excellence, holistic development, and community engagement.
      </Typography>
      <Button
        component={NavLink}
        to="/principalmessage"
        size="small"
        sx={{ mt: 1, textTransform: "none", fontWeight: 700, px: 0 }}
      >
        Read more →
      </Button>
    </Box>
  </Card>
</Grid>




          {/* About College (quick facts) */}
          <Grid item xs={12} md={5} id="about-section">
            <Card
              elevation={0}
              sx={{
                p: { xs: 1.75, sm: 2.25 },
                borderRadius: 3,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
                border: (t) => `1px solid ${t.palette.divider}`,
                bgcolor: "background.paper",
              }}
            >
              <Typography sx={{ fontWeight: 800, mb: 1, fontSize: { xs: 16, sm: 17 } }}>
                About AISECT Inter College
              </Typography>
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: { xs: 14, sm: 14.5 },
                  lineHeight: 1.8,
                }}
              >
                Established in 2023 at Matwari, Hazaribagh (Jharkhand), AIU delivers quality
                intermediate education across Science, Arts, and Commerce with a learner-centric
                approach and modern infrastructure.
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(2, 1fr)" },
                  gap: 1.25,
                  mt: 2,
                }}
              >
                {[
                  { k: "Streams", v: "Science · Commerce · Arts" },
                  { k: "Founded", v: "2023" },
                ].map((s) => (
                  <Box
                    key={s.k}
                    sx={{
                      p: 1.1,
                      borderRadius: 2,
                      bgcolor: "action.hover",
                      border: (t) => `1px dashed ${t.palette.divider}`,
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, fontSize: 13.5 }}>{s.k}</Typography>
                    <Typography sx={{ color: "text.secondary", fontSize: 13.5 }}>{s.v}</Typography>
                  </Box>
                ))}
              </Box>

              <Box sx={{ mt: "auto" }}>
                <Button
                  component={NavLink}
                  to="/about#about-section"
                  size="small"
                  sx={{ mt: 1.75, textTransform: "none", fontWeight: 700 }}
                >
                  Read more →
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* ======= Mission & Vision (anchor sections) ======= */}
      <Container maxWidth="lg" sx={{ mb: { xs: 4, md: 6 } }}>
        <Grid container spacing={{ xs: 2, sm: 2.5 }}>
          <Grid item xs={12} md={6} id="mission">
            <Card
              elevation={0}
              sx={{
                p: { xs: 1.75, sm: 2.25 },
                borderRadius: 3,
                boxShadow: "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
                border: (t) => `1px solid ${t.palette.divider}`,
              }}
            >
              <Typography sx={{ fontWeight: 800, mb: 1, fontSize: { xs: 16, sm: 17 } }}>
                Our Mission
              </Typography>
              <Typography sx={{ color: "text.secondary", fontSize: { xs: 14, sm: 14.5 }, lineHeight: 1.8 }}>
                To nurture confident, compassionate, and competent learners by providing a
                value-based education that blends academics with character building and real-world
                skills.
              </Typography>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} id="vision">
            <Card
              elevation={0}
              sx={{
                p: { xs: 1.75, sm: 2.25 },
                borderRadius: 3,
                boxShadow: "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
                border: (t) => `1px solid ${t.palette.divider}`,
              }}
            >
              <Typography sx={{ fontWeight: 800, mb: 1, fontSize: { xs: 16, sm: 17 } }}>
                Our Vision
              </Typography>
              <Typography sx={{ color: "text.secondary", fontSize: { xs: 14, sm: 14.5 }, lineHeight: 1.8 }}>
                To be a leading institution known for academic excellence, innovation, and an
                inclusive community that inspires lifelong learning and responsible citizenship.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* ======= (Your existing template sections kept as-is) ======= */}
      {/* CTA, Why Learn, full Principal section, separator, Footer — unchanged */}
      <Footer />
    </>
  );
}

export default About;


// import React, { useRef, useState } from "react";
// import Footer from "./footer";
// import ReactTyped from "react-typed";
// import Header from "./header";
// import { Box, Typography } from "@mui/material";

// function About() {
//   var bRef = React.useRef();

//   var textList = ["Mission.", "Vision.", "Planning.", "AISECT"];
//   const [nameIndex, setNameIndex] = useState(0); 
//   var intervalId = useRef();

//   return (
//     <>
//       <Header />
//       <div id="about-section">
//         {/* Start Banner Area */}
//         <div className="rbt-banner-area rbt-banner-8 variation-02">
//           <div className="container">
//             <div className="row g-5 align-items-center">
//               <div className="col-lg-10 offset-lg-1">
//                 <div className="content text-center">
//                   <div className="rbt-new-badge rbt-new-badge-one">
//                     <span className="rbt-new-badge-icon">🏆</span> The Leader in Campus Learning
//                   </div>
//                   <h1 className="title">
//                     Read About Our <Box component="span"></Box>
//                     <ReactTyped
//                       className="theme-gradient is-visible"
//                       strings={textList}
//                       typeSpeed={100}
//                       loop
//                       backSpeed={20}
//                       cursorChar=">"
//                       showCursor={true}
//                     />
//                   </h1>
//                   <p className="description has-medium-font-size mt--20">
//                     AISECT Inter College, We provide the best possible
//                     learning Environment through our best teaching and learning
//                     Experiences.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* End Banner Area */}

//         {/* About Area */}
//         <div className="rbt-about-area about-style-1 bg-color-white rbt-section-gap">
//           <div className="container">
//             <div className="row g-5 align-items-center">
//               {/* Image */}
//               <div className="col-lg-6 col-md-12 text-center">
//                 <div className="content">
//                   <img
//                     src="assets/images/logo/aisect_inter_college_logo.png"
//                     alt="About AISECT"
//                     style={{ maxWidth: "100%", height: "auto" }}
//                   />
//                 </div>
//               </div>

//               {/* Text */}
//               <div className="col-lg-6 col-md-12">
//                 <div className="inner pl--50 pl_sm--5">
//                   <div className="content text-start">
//                     <span className="rbt-badge-6 bg-primary-opacity">About AISECT</span>
//                     <h3 className="title mt-2">
//                       Welcome to AISECT Inter College for your learning & skills upgradation.
//                     </h3>
//                     <p className="description mt--30">
//                       <strong>AISECT Inter College is an educational Institute</strong>
//                     </p>
//                     {/* <p className="description">
//                       The AISECT Inter College is Recognised by AISECT University, Hazaribagh.
//                       It is our responsibility to upgrade your skills and learning through
//                       better course structure & faculties.
//                     </p> */}
//                     <p className="description">The AISECT Inter College (Letter No./JAC/Co Est./485/17 – 4693/22) dated
// 													29.12.2022was established in the year June 2023. It aim to build future
// 													citizenship by getting inspired with the vision, mission and ultimate goal of my
// 													institution. I wish to have overall development of my students which include
// 													academic, physical, creative social, global understanding along with skill
// 													development. </p>
// 												<p className="description">The courses inculcate the students to meet the challenges in areas of Arts,
// 													Science and Commerce. Our college get affiliated through Jharkhand Academic
// 													Council (JAC), Ranchi (Jharkhand). We are in process for the permanent
// 													affiliation to increase the number of students as in the ratio of present
// 													criteria. After getting the affiliation we can able to provide scholarship to our
// 													students. Basically, in Hazaribag the ratio of Inter College with the complete
// 													infrastructure is very minimum as the other corresponding degree college. We have
// 													granted permission of taking admission of only 128 students in each stream i. e.
// 													Arts, Science and Commerce.</p>
// 												<p className="description">Our College leads towards new height with the cooperation and support of our
// 													teachers, students in co- curricular activities along with academic excellence.
// 													With the help of dedicated teachers and committed staff. I believe in providing
// 													personal care to develop sensitivity among my students for their welfare.
// 													Instilling good values, having faith in our culture, sensing pride in our history
// 													along with the professional aptitude of my team inspire me to develop my students
// 													into future citizen. I think long term goal and success may be achieved in
// 													corruption free and congenial environment. My institution present a mosaic of
// 													local, national and international standard inspiring all stakeholders Education
// 													filled of fun and values not only help in bringing students and teachers up to
// 													great height in all spheres of life but also make life comfortable and stress
// 													free. </p>
//                     <div className="read-more-btn mt--40">
//                       <a
//                         className="rbt-btn rbt-marquee-btn radius-round btn-gradient"
//                         href="#"
//                       >
                        
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Call To Action */}
//         <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-8">
//           <div className="rbt-callto-action rbt-cta-default style-6">
//             <div className="container">
//               <div className="row g-5 align-items-center content-wrapper">
//                 <div className="col-lg-3 col-md-12">
//                   <h2 className="title color-white mb--0">Scholarship Programs</h2>
//                 </div>
//                 <div className="col-lg-6 col-md-12">
//                   <p className="color-white">
//                     Apply for Admission in Intermediate. Application Deadline:
//                     26th September 2023 · 20% Waiver on ...
//                   </p>
//                 </div>
//                 <div className="col-lg-3 col-md-12 text-md-start text-lg-end">
//                   <a className="rbt-btn btn-white hover-icon-reverse" href="#">
//                     <span className="icon-reverse-wrapper">
//                       <span className="btn-text">Financial Aid</span>
//                       <span className="btn-icon"><i className="feather-arrow-right" /></span>
//                     </span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Why Learn */}
//         <div className="rbt-service-area bg-color-white rbt-section-gap">
//           <div className="container">
//             <div className="row mb--60">
//               <div className="col-12 text-center">
//                 <h2 className="title">Why learn with our courses?</h2>
//                 <p className="description mt--30">
//                   <strong>AISECT Inter College</strong> — We provide the best environment to study
//                 </p>
//               </div>
//             </div>
//             <div className="row row--15 mt_dec--30">
//               {[
//                 { img: "001-bulb.png", title: "Your Apply", desc: "Fill out the admission form" },
//                 { img: "002-hat.png", title: "We Connect", desc: "We connect you with the right learning" },
//                 { img: "003-id-card.png", title: "You Get Ready", desc: "Prepare for your next step" },
//                 { img: "004-pass.png", title: "Completed", desc: "Graduate with skills & confidence" }
//               ].map((item, i) => (
//                 <div key={i} className="col-lg-3 col-md-6 col-12 mt--30">
//                   <div className="service-card service-card-6">
//                     <div className="inner">
//                       <div className="icon">
//                         <img src={`assets/images/icons/${item.img}`} alt={item.title} />
//                       </div>
//                       <div className="content">
//                         <h6 className="title"><a href="#">{item.title}</a></h6>
//                         <p className="description">{item.desc}</p>
//                       </div>
//                       <span className="number-text">{i + 1}</span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Principal Section */}
//         <div className="rbt-team-area bg-gradient-8 rbt-section-gap">
//           <div className="container">
//             <Box className="row mb--60 g-5">
//               <Box
//                 className="col-lg-4 col-md-6 col-12"
//                 sx={{
//                   height: { xs: "300px", md: "500px" },
//                   overflow: "hidden",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   src="assets/images/team/principal.jpeg"
//                   alt="Principal"
//                   style={{ width: "80%", height: "100%", objectFit: "cover" }}
//                 />
//               </Box>
//               <Box className="col-lg-6 col-md-6 col-12" sx={{ color: "white" }}>
//                 <span className="subtitle bg-white-opacity">Our Principal</span>
//                  <p>It is with great pride and enthusiasm that I welcome you to our college in it’s
// 													3rd year of establishment. Through still young in age, the institution has
// 													already began to make a mark in the field of education through commitment to
// 													academic excellence, holistic development and community engagement.</p>
// 												 <p>From humble beginning we have steadily grown building not only infrastructure but
// 													also a strong foundation of values innovation and student centered learning. Our
// 													dedicated faculty, motivated students and supportive community are the pillars
// 													that drive us forward each day.</p>
// 												<p>We aim to empower our students not just exceed academically but also to become
// 													responsible citizens and future leaders. We look to the future to remain
// 													committed to continuous improvement and the pursuit of excellence. I invite you
// 													to be part of this journey to learn, to grow and to shape a brighter tomorrow
// 												</p> 
//                 {/* <Typography sx={{ fontSize: { xs: 18, md: 20 } }}>
//                   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis error dolore facilis pariatur laudantium..."
//                 </Typography> */}
//               </Box>
//             </Box>
//           </div>
//         </div>

//         <div className="rbt-separator-mid">
//           <div className="container">
//             <hr className="rbt-separator m-0" />
//           </div>
//         </div>
//       </div>
//       <Box sx={{ pb: "30px" }}></Box>
//       <Footer />
//     </>
//   );
// }

// export default About;


// import React, { useEffect, useRef, useState } from "react";
// import Footer from "./footer";
// import ReactTyped from "react-typed";
// import Header from "./header";
// import { animated, useSpring } from "@react-spring/web";
// import { Box, Typography } from "@mui/material";

// function About() {
//   var bRef = React.useRef();

//   var textList = ["Mission.", "Vision.", "Planning.", "AISECT"];
//   var counter = 0;
//   const [nameIndex, setNameIndex] = useState(0); //start with the first name
//   var intervalId = useRef();

//   // function changeName() {
//   //   var nextIndex = nameIndex + 1;
//   //   if (nextIndex === textList.length - 1) {
//   //     clearInterval(intervalId.current);
//   //     bRef.current.innerText = textList[nextIndex];
//   //     nextIndex++;
//   //   }
//   //   if (!textList[nextIndex]) {
//   //     return; //if the current index does not exist, break the function
//   //   }
//   //   setNameIndex(nextIndex);
//   // }
//   // var inst = setInterval(changeText, 3000);
//   const [props, api] = useSpring(
//     () => ({
//       from: { opacity: 0 },
//       to: { opacity: 1 },
//     }),
//     []
//   );
//   React.useEffect(() => {
//     // changeText();
//   }, []);
//   // function changeText() {
//   //   // textList.forEach((e) => {
//   //   if (counter <= textList.length - 1) {
//   //     bRef.current.innerText = textList[counter];
//   //     counter++;
//   //     // console.warn(textList[counter - 1]);
//   //   }
//   //   if (!textList[counter]) {
//   //     counter = 0;
//   //     return; //if the current index does not exist, break the function
//   //   }
//   // }

//   return (
//     <>
//       <Header />
//       <div>
//         {/* Start Banner Area */}
//         <div className="rbt-banner-area rbt-banner-8 variation-02">
//           <div className="container">
//             <div className="row g-5 align-items-center">
//               <div className="col-lg-10 offset-lg-1">
//                 <div className="content">
//                   <div className="inner text-center">
//                     <div className="rbt-new-badge rbt-new-badge-one">
//                       <span className="rbt-new-badge-icon">🏆</span> The Leader
//                       in Campus Learning
//                     </div>
//                     <h1 className="title">
//                       Read About Our
//                       <Box></Box>
//                       <ReactTyped
//                         // style={{color:"blue"}}
//                         className="theme-gradient is-visible"
//                         strings={textList}
//                         typeSpeed={100}
//                         loop
//                         backSpeed={20}
//                         cursorChar=">"
//                         showCursor={true}
//                       />
//                       {/* <animated.div style={props}>
//                         <span className="header-caption">
//                           <span className="cd-headline clip is-full-width">
//                             <span className="cd-words-wrapper">
//                               <b
//                                 ref={bRef}
//                                 className="theme-gradient is-visible"
//                               >
//                                 Mission.
//                               </b>

//                               <b className="is-hidden theme-gradient">
//                                 Vission.
//                               </b>
//                               <b className="is-hidden theme-gradient">
//                                 Planning.
//                               </b>
//                             </span>
//                           </span>
//                         </span>
//                       </animated.div> */}
//                     </h1>
//                     <p className="description has-medium-font-size mt--20">
//                       AISECT Inter College, We provide the best possible
//                       learning Environment through our best teaching and leaning
//                       Experiences
//                     </p>
//                     {/* <div className="slider-btn rbt-button-group justify-content-center">
//                       <a
//                         className="rbt-btn btn-gradient hover-icon-reverse"
//                         href="#"
//                       >
//                         <span className="icon-reverse-wrapper">
//                           <span className="btn-text">Log in to Start</span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                         </span>
//                       </a>
//                       <a
//                         className="rbt-btn hover-icon-reverse btn-white"
//                         href="#"
//                       >
//                         <span className="icon-reverse-wrapper">
//                           <span className="btn-text">Contact US</span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                         </span>
//                       </a>
//                     </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* End Banner Area */}
//         {/* Start Video Area  */}
//         {/* <div className="rbt-video-area">
//           <div className="container">
//             <div className="row">
//               <div className="col-lg-12">
//                 <div className="video-popup-wrapper">
//                   <img
//                     className="w-100 rbt-radius"
//                     src="assets/images/bg/bg-image-12.jpg"
//                     alt="Video Images"
//                   />
//                   <a
//                     className="rbt-btn rounded-player-2 popup-video position-to-top with-animation btn-theme-color"
//                     href="https://www.youtube.com/watch?v=nA1Aqp0sPQo"
//                   >
//                     <span className="play-icon" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div> */}
//         {/* End Video Area  */}
//         <div className="rbt-about-area about-style-1 bg-color-white rbt-section-gap">
//           <div className="container">
//             <div className="row g-5 align-items-center">
//               <div className="col-lg-6">
//                 <div className="content">
//                   <img
//                     src="assets/images/logo/aisect_inter_college_logo.png"
//                     alt="About Images"
//                   />
//                 </div>
//               </div>
//               <div
//                 className="col-lg-6"
//                 // data-sal="slide-up"
//                 // data-sal-duration={700}
//               >
//                 <div className="inner pl--50 pl_sm--5">
//                   <div className="content text-start">
//                     <span className="rbt-badge-6 bg-primary-opacity">
//                       About AISECT
//                     </span>
//                     <h3 className="title">
//                       Welcome to AISECT Inter College for your learning & skills
//                       upgradation.
//                     </h3>
//                     <p className="description mt--30">
//                       <strong>
//                         AISECT Inter College is a educational Institute
//                       </strong>
//                     </p>
//                     <p className="description">
//                       The AISECT Inter College is Recognised by AISECT
//                       University, Hazaribagh. It is our Responsibility to
//                       upgrade your skills and learning through better Course
//                       sourse structure & faculties
//                     </p>
//                     <div className="read-more-btn mt--40">
//                       <a
//                         className="rbt-btn rbt-marquee-btn radius-round btn-gradient"
//                         href="#"
//                       >
//                         <span data-text="Start Learning For Free">
//                           Start Learning
//                         </span>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Start CallTo Action Area  */}
//         <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-8">
//           <div className="rbt-callto-action rbt-cta-default style-6">
//             <div className="container">
//               <div className="row g-5 align-items-center content-wrapper">
//                 <div className="col-xxl-3 col-xl-3 col-lg-6">
//                   <div className="inner">
//                     <div className="content text-start">
//                       <h2 className="title color-white mb--0">
//                         Scholarship Programs
//                       </h2>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xxl-6 col-xl-6 col-lg-6">
//                   <div className="inner-content text-start">
//                     <p className="color-white">
//                       Apply for Admission in Intermediate. Application Deadline:
//                       26th September 2023 · 20% Waiver on ...
//                     </p>
//                   </div>
//                 </div>
//                 <div className="col-xxl-3 col-xl-3 col-lg-6">
//                   <div className="call-to-btn text-start text-xl-end">
//                     <a
//                       className="rbt-btn btn-white hover-icon-reverse"
//                       href="#"
//                     >
//                       <span className="icon-reverse-wrapper">
//                         <span className="btn-text">Financial Aid</span>
//                         <span className="btn-icon">
//                           <i className="feather-arrow-right" />
//                         </span>
//                         <span className="btn-icon">
//                           <i className="feather-arrow-right" />
//                         </span>
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* End CallTo Action Area  */}
//         {/* Start Service Area */}
//         <div className="rbt-service-area bg-color-white rbt-section-gap">
//           <div className="container">
//             <div className="row mb--60">
//               <div className="col-lg-12">
//                 <div className="section-title text-center">
//                   <h2 className="title">Why learn with our courses?</h2>
//                   <p className="description mt--30">
//                     <strong>AISECT Inter College</strong> we provide best
//                     environment to study
//                   </p>
//                 </div>
//               </div>
//             </div>
//             {/* Start Card Area */}
//             <div className="row row--15 mt_dec--30">
//               {/* Start Service Grid  */}
//               <div className="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
//                 <div className="service-card service-card-6">
//                   <div className="inner">
//                     <div className="icon">
//                       <img
//                         src="assets/images/icons/001-bulb.png"
//                         alt="icons Images"
//                       />
//                     </div>
//                     <div className="content">
//                       <h6 className="title">
//                         <a href="#">Your Apply</a>
//                       </h6>
//                       <p className="description">
//                         To Join our college, First you have to fill out
//                         admission form
//                       </p>
//                     </div>
//                     <span className="number-text">1</span>
//                   </div>
//                 </div>
//               </div>
//               {/* End Service Grid  */}
//               {/* Start Service Grid  */}
//               <div className="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
//                 <div className="service-card service-card-6">
//                   <div className="inner">
//                     <div className="icon">
//                       <img
//                         src="assets/images/icons/002-hat.png"
//                         alt="Shape Images"
//                       />
//                     </div>
//                     <div className="content">
//                       <h6 className="title">
//                         <a href="#">We Connect</a>
//                       </h6>
//                       <p className="description">
//                         Javascript Learning looking for random paragraphs,
//                         you've come to the right place.
//                       </p>
//                     </div>
//                     <span className="number-text">2</span>
//                   </div>
//                 </div>
//               </div>
//               {/* End Service Grid  */}
//               {/* Start Service Grid  */}
//               <div className="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
//                 <div className="service-card service-card-6">
//                   <div className="inner">
//                     <div className="icon">
//                       <img
//                         src="assets/images/icons/003-id-card.png"
//                         alt="Shape Images"
//                       />
//                     </div>
//                     <div className="content">
//                       <h6 className="title">
//                         <a href="#">You Get Ready</a>
//                       </h6>
//                       <p className="description">
//                         Angular Learning looking for random paragraphs, you've
//                         come to the right place.
//                       </p>
//                     </div>
//                     <span className="number-text">3</span>
//                   </div>
//                 </div>
//               </div>
//               {/* End Service Grid  */}
//               {/* Start Service Grid  */}
//               <div className="col-lg-4 col-xl-3 col-xxl-3 col-md-6 col-sm-6 col-12 mt--30">
//                 <div className="service-card service-card-6">
//                   <div className="inner">
//                     <div className="icon">
//                       <img
//                         src="assets/images/icons/004-pass.png"
//                         alt="Shape Images"
//                       />
//                     </div>
//                     <div className="content">
//                       <h6 className="title">
//                         <a href="#">Completed</a>
//                       </h6>
//                       <p className="description">
//                         Php Learning looking for random paragraphs, you've come
//                         to the right place.
//                       </p>
//                     </div>
//                     <span className="number-text">4</span>
//                   </div>
//                 </div>
//               </div>
//               {/* End Service Grid  */}
//             </div>
//             {/* End Card Area */}
//           </div>
//         </div>
//         {/* End Service Area */}
//         <div className="rbt-team-area bg-gradient-8 rbt-section-gap">
//           <div className="container">
//             <Box className="row mb--60 g-5 ">
//               {/* Image Section */}
//               <Box
//                 className="col-lg-4 col-md-4 col-12"
//                 sx={{
//                   height: { xs: "300px", md: "500px" }, // Adjust height for different screen sizes
//                   width: { xs: "100%", md: "500px" },
//                   overflow: "hidden",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   src="assets/images/team/team-09.jpg"
//                   alt="Principal's Image"
//                   style={{ width: "80%", height: "100%", objectFit: "cover" }}
//                 />
//               </Box>
//               {/* Message Section */}
//               <Box
//                 className="col-lg-4 col-md-6 col-12"
//                 sx={{
//                   marginBottom: { xs: 3, md: 40 },
//                   marginLeft: { xs: 0, md: 20 },
//                 }}
//               >
//                 <Box className="section-title text-start">
//                   <span className="subtitle bg-white-opacity">
//                     Our Principal
//                   </span>
//                 </Box>
//                 <Typography
//                   sx={{ fontSize: { xs: 18, md: 25 }, color: "white" }}
//                 >
//                   {" "}
//                   "Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                   Veritatis error dolore facilis pariatur laudantium, dicta
//                   veniam accusantium ducimus officia? Optio perspiciatis
//                   voluptatibus odio id. Omnis pariatur provident nulla, amet
//                   maiores ut commodi veritatis porro option."
//                 </Typography>
//               </Box>
//             </Box>
//             <div
//               className="modal fade rbt-modal-default"
//               id="exampleModal"
//               tabIndex={-1}
//               aria-labelledby="exampleModal"
//               aria-hidden="true"
//             >
//               <div className="modal-dialog modal-dialog-centered">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <button
//                       type="button"
//                       className="rbt-round-btn"
//                       data-bs-dismiss="modal"
//                       aria-label="Close"
//                     >
//                       <i className="feather-x" />
//                     </button>
//                   </div>
//                   <div className="modal-body">
//                     <div className="inner">
//                       <div className="row g-5 row--30 align-items-center">
//                         <div className="col-lg-4">
//                           <div className="rbt-team-thumbnail">
//                             <div className="thumb">
//                               <img
//                                 className="w-100"
//                                 src="assets/images/team/team-09.jpg"
//                                 alt="Testimonial Images"
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-lg-8">
//                           <div className="rbt-team-details">
//                             <div className="author-info">
//                               <h4 className="title">Mames Mary</h4>
//                               <span className="designation theme-gradient">
//                                 English Teacher
//                               </span>
//                               <span className="team-form">
//                                 <i className="feather-map-pin" />
//                                 <span className="location">
//                                   CO Miego, AD,USA
//                                 </span>
//                               </span>
//                             </div>
//                             <p className="mb--15">
//                               You can run Histudy easily. Any School,
//                               University, College can be use this histudy
//                               education template for their educational purpose.
//                               A university can be success you.
//                             </p>
//                             <p>
//                               Run their online leaning management system by
//                               histudy education template any where and time.
//                             </p>
//                             <ul className="social-icon social-default mt--20 justify-content-start">
//                               <li>
//                                 <a href="https://www.facebook.com/">
//                                   <i className="feather-facebook" />
//                                 </a>
//                               </li>
//                               <li>
//                                 <a href="https://www.twitter.com/">
//                                   <i className="feather-twitter" />
//                                 </a>
//                               </li>
//                               <li>
//                                 <a href="https://www.instagram.com/">
//                                   <i className="feather-instagram" />
//                                 </a>
//                               </li>
//                               <li>
//                                 <a href="https://www.linkdin.com/">
//                                   <i className="feather-linkedin" />
//                                 </a>
//                               </li>
//                             </ul>
//                             <ul className="rbt-information-list mt--25">
//                               <li>
//                                 <a href="#">
//                                   <i className="feather-phone" />
//                                   +1-202-555-0174
//                                 </a>
//                               </li>
//                               <li>
//                                 <a href="mailto:hello@example.com">
//                                   <i className="feather-mail" />
//                                   example@gmail.com
//                                 </a>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="top-circle-shape" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rbt-separator-mid">
//           <div className="container">
//             <hr className="rbt-separator m-0" />
//           </div>
//         </div>
//       </div>
//       <Box sx={{ pb: "30px" }}></Box>
//       <Footer />
//     </>
//   );
// }
// export default About;
